import React from 'react';
import { Card } from '../../../components/base/Card';

export const ModelSection: React.FC = () => {
  return (
    <>
      {/* El Modelo BiviLinks */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-primary-800 mb-6">
              El Modelo BiviLinks
            </h2>
            <div className="w-24 h-1 bg-primary-600 mx-auto mb-8"></div>
            <p className="text-2xl text-primary-700 font-semibold">
              Transformamos relaciones en ingresos
            </p>
          </div>

          <div className="overflow-x-auto mb-12">
            <table className="w-full border-collapse bg-white shadow-xl rounded-lg overflow-hidden">
              <thead>
                <tr className="bg-primary-600 text-white">
                  <th className="px-6 py-4 text-left text-lg font-semibold">Rol</th>
                  <th className="px-6 py-4 text-left text-lg font-semibold">Qué hace</th>
                  <th className="px-6 py-4 text-left text-lg font-semibold">Qué gana</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-gray-200 hover:bg-primary-50 transition-colors">
                  <td className="px-6 py-4 font-semibold text-primary-800">Proveedor</td>
                  <td className="px-6 py-4 text-gray-700">Ofrece su servicio o producto</td>
                  <td className="px-6 py-4 text-gray-700">Clientes nuevos</td>
                </tr>
                <tr className="border-b border-gray-200 hover:bg-primary-50 transition-colors">
                  <td className="px-6 py-4 font-semibold text-primary-800">Usuario final</td>
                  <td className="px-6 py-4 text-gray-700">Contrata o compra en la app</td>
                  <td className="px-6 py-4 text-gray-700">Soluciones confiables</td>
                </tr>
                <tr className="hover:bg-primary-50 transition-colors">
                  <td className="px-6 py-4 font-semibold text-primary-800">Referidor</td>
                  <td className="px-6 py-4 text-gray-700">Comparte su enlace y genera tráfico</td>
                  <td className="px-6 py-4 text-gray-700">Comisión por venta</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Ejemplo Práctico */}
          <div className="bg-gradient-to-br from-primary-50 to-white rounded-2xl p-8 md:p-12 shadow-lg">
            <h3 className="text-3xl font-bold text-primary-800 mb-8 text-center">
              Ejemplo Práctico
            </h3>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 bg-primary-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold">1</span>
                </div>
                <p className="text-gray-700">Te registras como referidor y recibes tu enlace personal.</p>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 bg-primary-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold">2</span>
                </div>
                <p className="text-gray-700">Lo compartes en redes sociales o por mensaje.</p>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 bg-primary-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold">3</span>
                </div>
                <p className="text-gray-700">Alguien contrata un servicio de plomería a través de tu enlace.</p>
              </div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 bg-primary-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold">4</span>
                </div>
                <p className="text-gray-700">El proveedor cobra por su trabajo.</p>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 bg-primary-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold">5</span>
                </div>
                <p className="text-gray-700">BiviLinks detecta que tú generaste esa venta.</p>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 bg-primary-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold">6</span>
                </div>
                <p className="text-gray-700">En tu panel aparece el ingreso de tu comisión automática.</p>
              </div>
            </div>
            
            <div className="text-center mt-12">
              <p className="text-2xl font-bold text-primary-800">
                Sencillo. Justo. Escalable.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Modelo de Negocio */}
      <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-primary-800 mb-6">
              Modelo de Negocio
            </h2>
            <div className="w-24 h-1 bg-primary-600 mx-auto mb-8"></div>
            <h3 className="text-2xl text-primary-700 font-semibold mb-8">
              ¿Cómo gana BiviLinks?
            </h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            <Card className="p-8 text-center hover:shadow-2xl transition-all duration-300 border-t-4 border-primary-600">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-hand-coin-line text-3xl text-primary-600"></i>
              </div>
              <p className="text-gray-700 leading-relaxed">
                Los proveedores pagan una pequeña comisión por cada venta o contratación que proviene de BiviLinks.
              </p>
            </Card>

            <Card className="p-8 text-center hover:shadow-2xl transition-all duration-300 border-t-4 border-primary-600">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-share-line text-3xl text-primary-600"></i>
              </div>
              <p className="text-gray-700 leading-relaxed">
                BiviLinks comparte un porcentaje con el referidor que generó esa conexión.
              </p>
            </Card>

            <Card className="p-8 text-center hover:shadow-2xl transition-all duration-300 border-t-4 border-primary-600">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-settings-3-line text-3xl text-primary-600"></i>
              </div>
              <p className="text-gray-700 leading-relaxed">
                El resto se usa para mantener la plataforma, soporte y desarrollo.
              </p>
            </Card>
          </div>

          <div className="bg-primary-600 rounded-2xl p-12 text-center shadow-2xl">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-white">
              <div>
                <p className="text-xl font-semibold mb-2">El proveedor vende.</p>
              </div>
              <div>
                <p className="text-xl font-semibold mb-2">El referidor cobra.</p>
              </div>
              <div>
                <p className="text-xl font-semibold mb-2">El usuario resuelve su necesidad.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
